import { ThemeOption } from '../../types';

import { sendObject } from './handler';

export type SetTheme = { type: 'setTheme'; theme: ThemeOption };

export const postSetTheme = async (theme: ThemeOption): Promise<void> =>
  sendObject({ type: 'setTheme', theme });
